import { Component, computed, Input, OnChanges, Signal, signal, WritableSignal } from '@angular/core';
import { ComponentChanges } from '@app/utils/simpleChangesType';
import { Block, BlockType, StepData } from '@shared/models/step.model';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TimeFormat } from '@app/components/pl-timepicker/pl-timepicker.component';
import { ParticipantService } from '@src/app/@shared/services/participant/participant.service';

export enum FormControlName {
  blocks = 'blocks',
}

interface LifeActBlocksForm {
  [FormControlName.blocks]: FormArray<FormControl<Block>>;
}

@Component({
  selector: 'pl-my-life-acts-blocks',
  templateUrl: './myLifeActsBlocks.component.html',
  styleUrl: `./myLifeActsBlocks.component.scss`,
})
export class MyLifeActsBlocksComponent implements OnChanges {
  @Input({ required: true }) public lifeactStepData!: StepData | null;

  public participantTimeFormat: Signal<TimeFormat> = computed(() => this.participantService.participantTimeFormat());

  public showEmptyState: WritableSignal<boolean> = signal(false);
  public breadcrumbs: WritableSignal<string> = signal('');

  public form: FormGroup<LifeActBlocksForm> = this.createForm();

  protected readonly BlockType: typeof BlockType = BlockType;
  protected readonly FormControlName: typeof FormControlName = FormControlName;

  constructor(private participantService: ParticipantService) {}

  protected createForm(): FormGroup<LifeActBlocksForm> {
    const fb: FormBuilder = new FormBuilder();
    return fb.nonNullable.group<LifeActBlocksForm>({
      [FormControlName.blocks]: fb.nonNullable.array<Block>([]),
    });
  }

  public get formArrayBlocks(): FormArray {
    return this.form.get(FormControlName.blocks) as FormArray;
  }

  public ngOnChanges(changes: ComponentChanges<MyLifeActsBlocksComponent>): void {
    if (changes.lifeactStepData) {
      const lifeactStepData: StepData | null = changes.lifeactStepData.currentValue;
      if (lifeactStepData) {
        this.formArrayBlocks.clear({ emitEvent: false });

        lifeactStepData.blocks.forEach((value: Block | null) => {
          if (value && value.element === BlockType.lifeAct) {
            this.formArrayBlocks.push(new FormControl(value), { emitEvent: false });
          }
        });

        this.breadcrumbs.set(lifeactStepData.breadcrumbs);
      } else {
        this.showEmptyState.set(true);
      }
    }
    console.log('\x1b[42m TONIO MyLifeActsDownloadButtonComponent ngOnChanges changes=', changes, '\x1b');
  }
}
